<template>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
        <section :class="this.name">
            <div id="tower1-bg" class="player"></div>
            <div id="tower2-bg" class="player"></div>
            <div class="bg"></div>
            <div class="content">
                <div class="cont">
                    <h2>오만의 탑</h2>
                    <p>올라갈수록 스펙터클해지는 흥미진진한 그 곳!</p>
                    <ul>
                        <li>몬스터 레벨 : [1~6층] 76~80Lv / [7층 이상] 78~80Lv</li>
                        <li>필드레이드 : 1층 부터 시작하는 순차형 레이드 (예. 1층 처치 시 상위층 보스 출현)</li>
                    </ul>
                </div>
                <div class="cont">
                    <h2>바이움</h2>
                    <p>오픈 된 공간에서 바이움에 바로 도전!</p>
                    <ul>
                        <li>스폰위치 : 오만의 탑 14층</li>
                        <li>몬스터레벨 : 80Lv</li>
                        <li> 참여방법 : 입장조건 없이 바이움 등장 시 바로 도전 가능</li>
                    </ul>
                </div>
                <slide id="tower-slider" ref="tower1"
                       :slideList="slideData.tower1.list"
                       :width="603"
                       :height="384"
                       :noPagination="false">

                    <img class="promokit-slide__img" :src="`${this.$staticUrl}img/con6_slide_1.jpg`" alt="" slot="slide0"/>
                    <img class="promokit-slide__img" :src="`${this.$staticUrl}img/con6_slide_2.jpg`" alt="" slot="slide1"/>
                    <img class="promokit-slide__img" :src="`${this.$staticUrl}img/con6_slide_3.jpg`" alt="" slot="slide2"/>
                </slide>
            </div>
        </section>
    </transition>
</template>
<script>
    import BasePage from "./mixins/basePage.js";
    import {rePostionContents, reSizeBackground} from '@/utils/cavasResize';
    import canvasObjPosition from '@/utils/canvasObjPosition';
    import Slide from "@/components/TheSlide"

    export default {
        name: "tower",
        mixins: [BasePage],
        data() {
            return {
                name: "tower",
                contentData: [
                    {type: "bg", source: this.$staticUrl + "img/bg6.jpg", objName: "bg"},
                ],
                mouseX:0,
                mouseY:0,
                isMouseMove:false,
                isViewCon:false,
                selectNum:2,
                conObjPos:[
                    {imgX:-421, imgY:511, titX:-249, titY:242, lineX:-252, lineY:355,  txt1X:-274, txt1Y:373,  txt2X:-256, txt2Y:414, tit2X:353, tit2Y:423, tit3X:118, tit3Y:242},
                    {imgX:-220, imgY:256, lineX:219, lineY:355, titX:222, titY:242,  txt1X:250, txt1Y:373,  txt2X:265, txt2Y:414, tit2X:611, tit2Y:423, tit3X:100, tit3Y:242}
                ],
                bgPlayer1:null,
                bgPlayer2:null,
                slideData: {
                    tower1: {
                        list: 3,
                        index: 0
                    },
                }
            };
        },
        components:{
            Slide
        },
        methods: {
            canvasSet() {
                TweenMax.set(this.$el.querySelector('#tower-slider'), {css:{display:'none'}});
                this.bgPlayer1 = new nc.promokit.Player({
                    selector: '#tower1-bg',
                    videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/bg6_1.mp4',
                    mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:true
                });
                this.bgPlayer1.pause();
                TweenMax.set(this.$el.querySelector('#tower1-bg'), {autoAlpha:0});

                this.bgPlayer2 = new nc.promokit.Player({
                    selector: '#tower2-bg',
                    videoId: 'https://vod.plaync.com/lineage2/old/190220_jinkamael/baium.mp4',
                    mute: true,
                    controls: false,
                    coverClick: false,
                    loop: true,
                    autoPlay:true
                });
                this.bgPlayer2.pause();
                TweenMax.set(this.$el.querySelector('#tower2-bg'), {autoAlpha:0});

                this.baseCavasSet(this.contentData);

                let boxW = this.documentSetSize.width/2;
                let boxH = this.documentSetSize.height;
                let thisV = this;
                for(let i = 0; i<2; i++){
                    this.cvObj['conBox'+i] = new PIXI.Container();

                    this.canvas.stage.addChild(this.cvObj['conBox'+i]);


                    this.cvObj['conBg'+i] =  new PIXI.Sprite.fromImage(this.$staticUrl+`img/bg_6_${i+1}.jpg`);
                    this.cvObj['conBg'+i].alpha =1;
                    this.cvObj['conBox'+i].addChild(this.cvObj['conBg'+i]);
                    reSizeBackground(this.cvObj['conBg'+i], this.documentSetSize.width, this.documentSetSize.height);


                    this.cvObj['conMask'+i] = new PIXI.Graphics(0, 0);
                    this.cvObj['conMask'+i].beginFill(0xFFFF00);
                    this.cvObj['conMask'+i].drawRect(0, 0, boxW, boxH);
                    this.cvObj['conMask'+i].x =boxW * i;
                    this.cvObj['conMask'+i].y = 0;
                    this.canvas.stage.addChild(this.cvObj['conMask'+i]);
                    //
                    // this.cvObj['conMask'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/bg_${i+1}.jpg`);
                    // this.cvObj['conMask'+i].x = boxW * i;
                    // this.cvObj['conMask'+i].width = boxW;
                    // this.cvObj['conMask'+i].height = boxH;
                    // this.canvas.stage.addChild(this.cvObj['conMask'+i]);
                     this.cvObj['conBox'+i].mask = this.cvObj['conMask'+i];

                    this.cvObj['conCover'+i] = new PIXI.Sprite(PIXI.Texture.WHITE);
                    this.cvObj['conCover'+i].x = boxW * i;
                    this.cvObj['conCover'+i].width = boxW;
                    this.cvObj['conCover'+i].height = boxH;

                    this.cvObj['conCover'+i].tint = 0x000000;
                    this.cvObj['conCover'+i].alpha = 0;
                    this.cvObj['conBox'+i].addChild(this.cvObj['conCover'+i]);
                    //this.cvObj['conCover'+i].mask = this.cvObj['conMask'+i];

                    this.cvObj['objCon'+i] = new PIXI.Container();
                    this.cvObj['conBox'+i].addChild( this.cvObj['objCon'+i]);
                    this.cvObj['obj'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/obj_6_${i+1}.png`);
                    canvasObjPosition(this.cvObj['obj'+i], this.cvObj['objCon'+i], boxW + this.conObjPos[i].imgX, this.conObjPos[i].imgY);
                    if(i == 0)canvasObjPosition(this.cvObj['obj'+i], this.cvObj['objCon'+i], boxW + this.conObjPos[i].imgX, this.conObjPos[i].imgY);
                    if(i == 1)canvasObjPosition(this.cvObj['obj'+i], this.cvObj['objCon'+i], boxW*2 + this.conObjPos[i].imgX, this.conObjPos[i].imgY);

                    this.cvObj['activeTitCon'+i] = new PIXI.Container();
                    this.cvObj['conBox'+i].addChild( this.cvObj['activeTitCon'+i]);
                    this.cvObj['activeTit'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_6_${i+1}_tit_active.png`);
                    if(i == 0)canvasObjPosition(this.cvObj['activeTit'+i], this.cvObj['activeTitCon'+i], this.conObjPos[i].tit2X, this.conObjPos[i].tit2Y);
                    if(i == 1)canvasObjPosition(this.cvObj['activeTit'+i], this.cvObj['activeTitCon'+i], boxW*2-this.conObjPos[i].tit2X, this.conObjPos[i].tit2Y);
                    this.cvObj['activeTit'+i].alpha = 0

                    this.cvObj['deactiveTit'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_6_${i+1}_tit2.png`);
                    if(i == 0)canvasObjPosition(this.cvObj['deactiveTit'+i], this.cvObj['conBox'+i], this.conObjPos[i].tit3X, this.conObjPos[i].tit3Y);
                    if(i == 1)canvasObjPosition(this.cvObj['deactiveTit'+i], this.cvObj['conBox'+i], boxW*2-this.conObjPos[i].tit3X, this.conObjPos[i].tit3Y);
                    this.cvObj['deactiveTit'+i].alpha = 0

                    this.cvObj['conTxtBox'+i] = new PIXI.Container();
                    this.cvObj['conBox'+i].addChild(this.cvObj['conTxtBox'+i]);

                    this.cvObj['txtTitleCon'+i] = new PIXI.Container();
                    this.cvObj['conTxtBox'+i].addChild( this.cvObj['txtTitleCon'+i]);
                    this.cvObj['txtTitle'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_6_${i+1}_tit.png`);
                    canvasObjPosition(this.cvObj['txtTitle'+i], this.cvObj['txtTitleCon'+i], boxW + this.conObjPos[i].titX, this.conObjPos[i].titY);


                    this.cvObj['txtTitleLineCon'+i] = new PIXI.Container();
                    this.cvObj['conTxtBox'+i].addChild( this.cvObj['txtTitleLineCon'+i]);
                    this.cvObj['txtTitleLine'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_6_${i+1}_line.png`);
                    canvasObjPosition(this.cvObj['txtTitleLine'+i], this.cvObj['txtTitleLineCon'+i], boxW + this.conObjPos[i].lineX, this.conObjPos[i].lineY);

                    this.cvObj['txt1Con'+i] = new PIXI.Container();
                    this.cvObj['conTxtBox'+i].addChild(this.cvObj['txt1Con'+i]);
                    this.cvObj['txt1_'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_6_${i+1}_txt_1.png`);
                    canvasObjPosition(this.cvObj['txt1_'+i], this.cvObj['txt1Con'+i], boxW+ this.conObjPos[i].txt1X, this.conObjPos[i].txt1Y);


                    this.cvObj['txt2Con'+i] = new PIXI.Container();
                    this.cvObj['conTxtBox'+i].addChild(this.cvObj['txt2Con'+i]);
                    this.cvObj['txt2_'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/txt_6_${i+1}_txt_2.png`);
                    canvasObjPosition(this.cvObj['txt2_'+i], this.cvObj['txt2Con'+i], boxW+ this.conObjPos[i].txt2X, this.conObjPos[i].txt2Y);

                    //this.cvObj['conObj'+i] = new PIXI.Sprite.fromImage(this.$staticUrl+`img/obj_6_${i+1}.png`);
                    //canvasObjPosition(this.cvObj['conObj'+i], this.cvObj['conBox'+i], boxW/2+this.conObjPos[i].imgX, this.conObjPos[i].imgY);

                    this.cvObj['conBox'+i].interactive = true;
                    this.cvObj['conBox'+i].cursor = 'pointer';
                    this.cvObj['conBox'+i].key = 'conBox'+i;
                    this.cvObj['conBox'+i].pointerover = function(e){
                        //console.log(this.key)
                        thisV.conOverMotion(this.key)
                    };
                    this.cvObj['conBox'+i].pointerdown = function(e){
                        //console.log(this.key)
                        thisV.conDownMotion(this.key)
                    };

                }
                this.canvas.stage.interactive = true;
                this.canvas.stage.pointerout = function(e){
                    thisV.conOverMotion('conBox2')
                };
            },
            conDownMotion(key){
                if(!this.isMouseMove)return;
                this.isViewCon = true;
                let num = key.slice(6);

                if(num == this.selectNum)return;
                let boxW = this.documentSetSize.width/2;
                let boxX = 0;
                let coverA = 0;
                this.selectNum = num;
                for(let i = 0; i<2; i++){
                    let tarW = boxW;
                    if(i == num){
                        tarW = this.documentSetSize.width-230;
                        coverA = 0;
                    }else{
                        tarW = 230;
                        coverA = 0.6;
                    }
                    if(2 == num){
                        tarW = boxW;
                        coverA = 0
                    }
                    TweenMax.to(this.cvObj['conMask'+i], 0.5, {width:tarW, x:boxX, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['conTxtBox'+i], 0.3, {alpha:0, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['conCover'+i], 0.5, {width:tarW, x:boxX, alpha:coverA, ease:Cubic.easeOut})

                    if( num == 1) {
                        //TweenMax.to(this.cvObj['objCon' + 1], 0.3, {x:0, y: -75, ease: Cubic.easeOut})
                    }

                    boxX += tarW;
                    this.cvObj['conMask'+i].height = this.documentSetSize.height;
                }
                if(num == 0){
                    TweenMax.to(this.cvObj['activeTit'+0], 0.3, {alpha:1,  ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['activeTit'+1], 0.3, {alpha:0, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['deactiveTit'+0], 0.3, {alpha:0, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['deactiveTit'+1], 0.3, {alpha:1, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['obj'+0], 0.3, {alpha:0, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['obj'+1], 0.3, {alpha:0, ease:Cubic.easeOut})

                    this.bgPlayer1.seek(1);
                    this.bgPlayer1.play();
                    TweenMax.set(this.$el.querySelector('#tower1-bg'), {autoAlpha:1})
                    TweenMax.set(this.$el.querySelector('#tower2-bg'), {autoAlpha:0})
                    TweenMax.to(this.cvObj['conBg'+0], 0.7, {pixi: { alpha: 0}, delay:0.5 })

                    this.bgPlayer2.pause();
                    TweenMax.to(this.cvObj['conBg'+1], 0, {pixi: { alpha: 1} })

                    TweenMax.set(this.$el.querySelector('#tower-slider'), {css:{display:'block', alpha:0}});
                    TweenMax.to(this.$el.querySelector('#tower-slider'), 0.5, {alpha: 1, delay:0.3 })

                    this.cvObj['conBox'+0].cursor = 'default';
                    this.cvObj['conBox'+1].cursor = 'pointer';

                }else{
                    TweenMax.to(this.cvObj['activeTit'+0], 0.3, {alpha:0, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['activeTit'+1], 0.3, {alpha:1, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['deactiveTit'+0], 0.3, {alpha:1, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['deactiveTit'+1], 0.3, {alpha:0, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['obj'+0], 0.3, {alpha:0, ease:Cubic.easeOut})
                    TweenMax.to(this.cvObj['obj'+1], 0.3, {alpha:1, ease:Cubic.easeOut})

                    this.bgPlayer2.seek(0.85);
                    this.bgPlayer2.play();
                    TweenMax.set(this.$el.querySelector('#tower2-bg'), {autoAlpha:1})
                    TweenMax.set(this.$el.querySelector('#tower1-bg'), {autoAlpha:0})
                    TweenMax.to(this.cvObj['conBg'+1], 0.3, {pixi: { alpha: 0}, delay:0.2})

                    this.bgPlayer1.pause();
                    TweenMax.to(this.cvObj['conBg'+0], 0, {pixi: { alpha: 1} })

                    TweenMax.set(this.$el.querySelector('#tower-slider'), {css:{display:'none'}});

                    this.cvObj['conBox'+1].cursor = 'default';
                    this.cvObj['conBox'+0].cursor = 'pointer';
                }

            },
            conOverMotion(key){
                if(!this.isMouseMove)return;
                let num = key.slice(6);
                let boxW = this.documentSetSize.width/2;
                let boxX = 0;
                let posX = 0;
                let coverA = 0;
                let speed = 0.5;


                for(let i = 0; i<2; i++){
                    let tarW = boxW;
                    if(!this.isViewCon){
                        if(i == num){
                            tarW = boxW+100;
                            posX =0;
                            coverA = 0;
                        }else{
                            tarW = boxW-100;
                            if(num == 0)posX =50;
                            if(num == 1)posX =-50;
                            coverA = 0.3;
                        }
                        if(2 == num){
                            tarW = boxW;
                            if(num == 0) posX =0;
                            if(num == 1)posX =0;
                            coverA = 0;
                        }

                        //TweenMax.to(this.cvObj['conBox'+i], 0.5, {x:posX, ease:Cubic.easeOut})

                        TweenMax.to(this.cvObj['txtTitle'+i], 0.5, {x:boxW + this.conObjPos[i].titX+posX, y:this.conObjPos[i].titY, ease:Cubic.easeOut})
                        TweenMax.to(this.cvObj['txtTitleLine'+i], 0.5, {x:boxW + this.conObjPos[i].lineX+posX, y:this.conObjPos[i].lineY, ease:Cubic.easeOut})
                        TweenMax.to(this.cvObj['txt1_'+i], 0.5, {x:boxW + this.conObjPos[i].txt1X+posX, y:this.conObjPos[i].txt1Y, ease:Cubic.easeOut})
                        TweenMax.to(this.cvObj['txt2_'+i], 0.5, {x:boxW + this.conObjPos[i].txt2X+posX, y:this.conObjPos[i].txt2Y, ease:Cubic.easeOut})
                        if(i==0)TweenMax.to(this.cvObj['obj'+i], 0.5, {x:boxW + this.conObjPos[i].imgX+posX, y:this.conObjPos[i].imgY, ease:Cubic.easeOut})
                        if(i==1)TweenMax.to(this.cvObj['obj'+i], 0.5, {x:boxW*2 + this.conObjPos[i].imgX+posX, y:this.conObjPos[i].imgY, ease:Cubic.easeOut})

                    }else{
                        speed = 0.2
                        if(num == 2)num = this.selectNum;
                        if(num == i){
                            if(i == this.selectNum){
                                tarW = this.documentSetSize.width - 230;
                                coverA = 0;
                            }else{
                                tarW = 260;
                                coverA = 0.3;
                            }

                        }else{
                            if(i == this.selectNum){
                                tarW = this.documentSetSize.width - 260;
                                coverA = 0;
                            }else{
                                tarW = 230;
                                coverA = 0.6;
                            }
                        }
                    }
                    TweenMax.to(this.cvObj['conCover'+i], speed, {width:tarW, x:boxX, alpha:coverA, ease:Power1.easeOut})
                    TweenMax.to(this.cvObj['conMask'+i], speed, {width:tarW, x:boxX, ease:Power1.easeOut})


                   // TweenMax.to(this.cvObj['activeTit'+i], 0.3, {alpha:1,  ease:Cubic.easeOut})
                  //  TweenMax.to(this.cvObj['deactiveTit'+i], 0.3, {alpha:1, ease:Cubic.easeOut})

                    if(i == 0) TweenMax.to(this.cvObj['activeTit'+i], 0, {x:this.conObjPos[i].tit2X, y: this.conObjPos[i].tit2Y,  ease:Cubic.easeOut})
                    if(i == 1) TweenMax.to(this.cvObj['activeTit'+i], 0, {x:this.documentSetSize.width - this.conObjPos[i].tit2X, y: this.conObjPos[i].tit2Y,  ease:Cubic.easeOut})

                    if(i == 0) TweenMax.to(this.cvObj['deactiveTit'+i], 0, {x:this.conObjPos[i].tit3X, y: this.conObjPos[i].tit3Y,  ease:Cubic.easeOut})
                    if(i == 1) TweenMax.to(this.cvObj['deactiveTit'+i], 0, {x:this.documentSetSize.width - this.conObjPos[i].tit3X, y: this.conObjPos[i].tit3Y,  ease:Cubic.easeOut})

                    if(i==0)TweenMax.to(this.cvObj['obj'+i], 0.5, {x:boxW + this.conObjPos[i].imgX+posX, y:this.conObjPos[i].imgY, ease:Cubic.easeOut})
                    if(i==1)TweenMax.to(this.cvObj['obj'+i], 0.5, {x:boxW*2 + this.conObjPos[i].imgX+posX, y:this.conObjPos[i].imgY, ease:Cubic.easeOut})

                    boxX += tarW;

                    this.cvObj['conCover'+i].height = this.documentSetSize.height;
                    this.cvObj['conMask'+i].height = this.documentSetSize.height;
                }

            },
            enter(el, done) {
                this.baseEnter();
                this.canvasSet();
                this.baseEnterMotion(el, done, this.contentData);

                this.enterMotion
                    .fromTo(this.cvObj.objCon0, 1.5, {pixi: { brightness: 0,  blur: 10}}, { pixi: { brightness: 1, blur: 0},ease:Power0.easeNone}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.obj0, 1.5, {pixi: {y:this.conObjPos[0].imgY+100,alpha:0}}, { pixi: {y:this.conObjPos[0].imgY,alpha:1},ease:Sine.easeOut}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.objCon1, 1.5, {pixi: { brightness: 0,  blur: 10}}, { pixi: { brightness: 1, blur: 0},ease:Power0.easeNone}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.obj1,1.5, {pixi: {y:this.conObjPos[1].imgY+100,alpha:0}}, { pixi: {y:this.conObjPos[1].imgY,alpha:1},ease:Sine.easeOut}, 'bgMotionEnd-=0.2')
                    .fromTo(this.cvObj.txtTitleCon0, 2, {pixi: { brightness: 5}}, { pixi: { brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitle0, 1, {pixi: { alpha: 0}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitleCon1, 2, {pixi: { brightness: 5}}, { pixi: { brightness: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitle1, 1, {pixi: { alpha: 0}}, { pixi: { alpha: 1},ease:Power0.easeNone}, 'bgMotionEnd-=0.5')
                    .fromTo(this.cvObj.txtTitleLine0, 0.5, {pixi: { alpha: 0, scale:0}}, {pixi:{scale:1, alpha:1}, ease:Back.easeOut}, 'bgMotionEnd+=0')
                    .fromTo(this.cvObj.txtTitleLine1, 0.5, {pixi: { alpha: 0, scale:0}}, {pixi:{scale:1, alpha:1}, ease:Back.easeOut}, 'bgMotionEnd+=0')
                    .fromTo(this.cvObj.txt1_0, 0.7, {pixi: { alpha: 0, scale:0.1}}, {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.4')
                    .fromTo(this.cvObj.txt1_1, 0.7, {pixi: { alpha: 0, scale:0.1}}, {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=0.4')
                    .fromTo(this.cvObj.txt1Con0, 0.7, {pixi: { blurX: 50}}, {pixi:{blurX:0}}, 'bgMotionEnd+=0.6')
                    .fromTo(this.cvObj.txt1Con1, 0.7, {pixi: { blurX: 50}}, {pixi:{blurX:0}}, 'bgMotionEnd+=0.6')
                    .fromTo(this.cvObj.txt2_0, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=1')
                    .fromTo(this.cvObj.txt2_1, 0.7,{pixi: { alpha: 0, scale:0.1}},  {pixi:{scale:1, alpha:1}, ease:Expo.easeOut}, 'bgMotionEnd+=1')
                    .fromTo(this.cvObj.txt2Con0, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}}, 'bgMotionEnd+=1')
                    .fromTo(this.cvObj.txt2Con1, 0.7,{pixi: { blurX: 50}},  {pixi:{blurX:0}, onComplete:()=>{this.isMouseMove = true;  this.conOverMotion('conBox2')}}, 'bgMotionEnd+=1')
                this.enterMotion.play();
            },
            leave(el, done) {
                if (this.enterMotion) this.enterMotion.pause();
                this.baseLeaveMotion(el, done);
            },

            resize(){
                this.documentSetSize.width =  document.querySelector('.container').clientWidth;
                this.documentSetSize.height = document.querySelector('.container').clientHeight;
                if(!this.canvas)return;
                reSizeBackground(this.cvObj.conBg0, this.documentSetSize.width, this.documentSetSize.height);
                reSizeBackground(this.cvObj.conBg1, this.documentSetSize.width, this.documentSetSize.height);
                rePostionContents(this.cvObj.con, this.documentSetSize.width, this.documentSetSize.height, this.contentSize.w, this.contentSize.h, true);

                this.conOverMotion('conBox2')
                this.canvas.renderer.resize(this.documentSetSize.width, this.documentSetSize.height);

            }
        }
    };
</script>

